export const getBase64Image = (img: string): string => {
  return img.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
};
